import React from "react";
import { toast } from "react-toastify";
import { ImportNotificationMessage } from "../general/ImportNotificationMessage";
import { FrameworkComparisonChangesNotificationMessage } from "../general/FrameworkComparisonChangesNotificationMessage";


class ToastService {
  func_notify = (message, type) => {
    switch (type) {
      case "error":
        toast.error(message, { autoClose: false });
        break;
      case "warn":
        toast.warn(message, { autoClose: false });
        break;
      default:
        if (
          message &&
          (message?.startsWith("Action MergeBranch") ||
            message?.startsWith("Action BuildRelease") ||
            message?.startsWith("Action Promote"))
        )
          toast(message, { autoClose: false });
          else toast(message);
    }
  };

  notifyWithComponent = (component, type) => {
    switch (type) {
      case "error":
        toast.error(component, { autoClose: false });
        break;
      case "warn":
        toast.warn(component, { autoClose: false });
        break;
      default:
        toast(component);
    }
  };

  func_notifyIfNeededAccordingImportResponse = (response) => {
    if (response && Object.keys(response).length > 0) {
      if (response.status && response.status === 500) {
        this.func_notify(
          "Import failed. Reason: " + response.message,
          "error"
        );
      } else {
        // if a message is provided display it, otherwise display the results
        if (response?.message) {
          toast(response.message)
        } else {
          const content = this.func_extractSuccessfulImportNotificationContent(response);

          const successfullyImported = content.filter(
              (detailsWrapper) => detailsWrapper.entitiesImportedCount !== -1
          );
          if (successfullyImported.length > 0) {
            toast(
                <ImportNotificationMessage
                    content={successfullyImported}
                    isError={false}
                />,
                { autoClose: false }
            );
          }

          const failedToImport = content.filter(
              (detailsWrapper) => detailsWrapper.entitiesImportedCount === -1
          );
          if (failedToImport.length > 0) {
            toast.error(
                <ImportNotificationMessage content={failedToImport} isError={true} />,
                { autoClose: false }
            );
          }
        }
      }
    }
  };

  notifyAboutFrameworkComparisonChanges = (content) => {
    toast(<FrameworkComparisonChangesNotificationMessage content={content} />, {
      autoClose: false,
    });
  };

  func_extractSuccessfulImportNotificationContent = (response) => {
    if (!response?.results) {
      return [];
    }
    
    const importDetails = response.results
    const content = [];
    Object.entries(importDetails).forEach(([key, value]) => {
      let entity = {};
      entity.name = key.toString();
      entity.entitiesImportedCount = value.importedRowCount
      entity.message = value.message;
      content.push(entity);
    })
    return content;
  };

  func_notifyIfNeededAccordingResponseEvent = (actionResult) => {
    if (actionResult) {
      if (actionResult.resultType) {
        const notificationStyle =
          actionResult.resultType === "ERROR"
            ? "error"
            : actionResult.resultType === "WARNING"
            ? "warn"
            : "info";
        
        const noDetailsMessage = "Action finished - no details.";

        this.func_notify(actionResult.resultMessage ? actionResult.resultMessage : noDetailsMessage, notificationStyle)

        if(actionResult.warningMessages && actionResult.warningMessages.length > 0) {
          actionResult.warningMessages.forEach(warningMessage => this.func_notify(warningMessage, "warn"));
        }   
      } else {
        if (actionResult.status && actionResult.status >= 400) {
          this.func_notify(
            "Sorry, something went wrong. Please ask the System Administrator to check the logs.",
            "error"
          );
        }
      }
    }
  };
}

const toastService = new ToastService();

export default toastService;

